import { render, staticRenderFns } from "./MinusSolidIcon.vue?vue&type=template&id=0b9aa43d&"
import script from "./MinusSolidIcon.vue?vue&type=script&lang=js&"
export * from "./MinusSolidIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports